import React from 'react';
import { TDR } from 'tdr-common';
import { customIcons, DynamicIcon } from '../icons';
import Chainlink from 'iconsax-react/dist/esm/Chainlink';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { resolveTableAttributeText } from '../../helpers/resolveTableAttributeText';

type TableTagProps = {
	label: TDR.Attributes.OptionValue | string;
	iconName?: string;
	classNames?: string
};

export const TableTag: React.FC<TableTagProps> = ({ label, iconName, classNames }) => {
	const { t, i18n } = useTranslation();

	if (!label) {
		return null;
	}

	const displayLabel = resolveTableAttributeText(label, t, i18n.language);

	return (
		<div className={cn('flex gap-1 items-center', classNames)}>
			{iconName ? customIcons()[iconName] ?? <DynamicIcon iconName={iconName} size={16} color={'#94969C'} /> : <Chainlink size={16} color={'#94969C'} />}
			<span className='text-zinc-300 font-poppins text-sm capitalize whitespace-nowrap truncate' title={displayLabel}>{displayLabel}</span>
		</div>
	);
};
